export const ERROR_CODE_LIST = {
    200: "Success",
    "00001": "User Inactive",
    "00002": "Short Time Lock  ",
    "00003": "Fixed Lock ",
    "00004": "Invalid Password", // (Not Contain "12345Aa@")
    "00005": "Unauthorized User",
    "00006": "Not Found User", // Invalid/Not Found username/Email
    "00007": "Invalid User Type",
    "00008": "Have no Country Permission",
    "00009": "Have no Application Permission",
    "00010": "Expired Password",
    "00011": "Wrong password",
    "00012": "Something Error", // DB/others Err
    "00013": "Email Already Exist",
    "00014": "Username Already Exist",
    "00015": "Invalid password Token", // Forgot password Token Invalid/Not Found
    "00016": "Expired password Token", // Forgot password Token Expired
    "00017": "Form Key is Empty",
    "00018": "ICC ID is Empty",
    "00019": "ICC Account Not Found",
    "00020": "ICC Profile token Not Found",
    "00021": "Data Already Exist",
    "00022": "Don't Set Password",
    "00023": "Email is Empty",
    "00024": "Address is Empty",
    "00025": "Invalid Email or Password",
    "00026": "You have used this password before. Please Try again.",
    "00027": "Basic Auth Confiruration is not Found",
    "00028": "JWT UnAuthorized/Invalid Secret",
    "00029": "JWT valid",
    "00030": "Invalid JWT/already insert JWT History",
    "00031": "Event already Registered",
    "00032": "Maximum Number participant’s registration",
    "00033": "Send To Email Config Not Fund",
    "00034": "Some Required field is Empty",
    "00035": "Email Not Found",
    23505: "Duplicate Data",
};
